import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import LoadingSpinner from '../../components/Common/LoadingSpinner';
import { ArrowLeftIcon, PencilIcon } from '@heroicons/react/24/outline';

const DeviceDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { get, loading } = useApi();
  const [device, setDevice] = useState(null);

  useEffect(() => {
    fetchDevice();
  }, [id]);

  const fetchDevice = async () => {
    const { data } = await get(`/api/devices/${id}`);
    if (data) setDevice(data);
  };

  if (loading) return <LoadingSpinner />;
  if (!device) return <div className="p-6">Device not found</div>;

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <button
            onClick={() => navigate('/devices/filter')}
            className="mr-4 text-gray-600 hover:text-gray-900"
          >
            <ArrowLeftIcon className="h-6 w-6" />
          </button>
          <h1 className="text-2xl font-bold text-gray-800">Device Details</h1>
        </div>
        <button
          onClick={() => navigate(`/devices/edit/${id}`)}
          className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 flex items-center space-x-2"
        >
          <PencilIcon className="h-5 w-5" />
          <span>Edit</span>
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-lg p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="text-sm text-gray-500">ID</label>
            <p className="text-lg font-medium">{device.id}</p>
          </div>
          <div>
            <label className="text-sm text-gray-500">Brand</label>
            <p className="text-lg font-medium">{device.brand}</p>
          </div>
          <div>
            <label className="text-sm text-gray-500">Device Type (devType)</label>
            <p className="text-lg font-medium">{device.devType}</p>
          </div>
          <div>
            <label className="text-sm text-gray-500">Device Type</label>
            <p className="text-lg font-medium">{device.deviceType?.description || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-500">Device Information</label>
            <p className="text-lg font-medium">{device.deviceType?.information || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-500">Orientation Type</label>
            <p className="text-lg font-medium">{device.orientationType?.description || '-'}</p>
          </div>
          <div className="md:col-span-2">
            <label className="text-sm text-gray-500">Other Information</label>
            <p className="text-lg font-medium">{device.other || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-500">Started At</label>
            <p className="text-lg font-medium">
              {device.startedAt ? new Date(device.startedAt).toLocaleString() : '-'}
            </p>
          </div>
          <div>
            <label className="text-sm text-gray-500">Ended At</label>
            <p className="text-lg font-medium">
              {device.endedAt ? new Date(device.endedAt).toLocaleString() : '-'}
            </p>
          </div>
          <div>
            <label className="text-sm text-gray-500">Status</label>
            <p className="text-lg font-medium">
              <span className={`px-2 py-1 rounded-full text-xs ${
                device.isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
              }`}>
                {device.isActive ? 'Active' : 'Inactive'}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeviceDetails;